export default __webpack_public_path__ + "static/media/mWN_referral_banner.983fe2fa.svg";